import { useMemo } from 'react';
import { PEPTIDE_OPTIONS } from '../../constants/peptides';
import { getRegimens } from '../../utils/storage/regimens';

export const useRegimenOptions = () => {
  return useMemo(() => {
    const regimens = getRegimens();
    const regimenNames = regimens.map(r => r.name);
    
    // Combine and deduplicate options
    const allOptions = [...new Set([...PEPTIDE_OPTIONS, ...regimenNames])];
    
    // Sort alphabetically
    return allOptions.sort((a, b) => a.localeCompare(b));
  }, []);
};